// Enum that represents feature flags that return EppoFeatureVariants
export enum EppoFeatureFlags {
  DEVICE_CLAIMING_PROCESS = "hubstaffapp_device_claiming_process",
  HIDE_PRODUCT_FACINGS = "hubstaffapp_hide_product_facings",
  LIST_VERIFICATION_HU_CHECK = "hubstaffapp_list_verification_hu_check",
  INTERCOM = "hubstaffapp_intercom",
  CAMPAIGN_PRODUCT = "hubstaffapp_campaign_product",
  WELCOME_FLYER = "hubstaffapp_welcome_flyer",
  RESTOCKING_THRESHOLD = "hubstaffapp_restocking_threshold",
  ENABLE_NEW_STOCK_CORRECTION_REASON = "hubstaffapp_enable_new_stock_correction_reason",
  ENABLE_SHELF_CHANGE_ASSISTANT = "hubstaffapp_enable_shelf_change_assistant",
  ENABLE_TRANSPORT_EQUIPMENT_FLOW = "hubstaffapp_enable_transport_equipment_flow",
  ENABLE_RESTOCKING_V2 = "hubstaffapp_enable_restocking_v2",
  // End of Year (EOY) Feature Flags
  EOY_SHOW_CHECKS = "hubstaffapp_show_eoy_checks", // Displays EOY/MOY-specific stock checks
  EOY_MODE_ENABLED = "hubstaffapp_enable_eoy_mode", // Enables EOY mode to restrict certain inventory operations during EOY
  EOY_HIDE_CORRECTIONS = "hubstaffapp_eoy_hide_corrections", // Restricts certain stock checks, deviations, and stock correction reasons during EOY
}

export enum EppoFeatureVariants {
  ON = "ON",
  OFF = "OFF",
  TRUE = "true",
  FALSE = "false",
}

// Enum that represents feature flags that return JSON data.
export enum EppoFeatureFlagsWithJson {
  TOO_GOOD_TO_GO_BAG_TYPES = "hubstaffapp_too_good_to_go_bag_types",
  STOCK_CHANGE_GUARDRAILS = "hubstaffapp_stock_change_guardrails",
}
